import { clearAuthSlice } from '../../store/reducers/authSlice';
import { clearChatSlice } from '../../store/reducers/chatSlice';
import {
  clearUISlice,
  setAutoSelectAgencyRole,
  setHasSkippedHelpSetup,
  setIsHelpSetupPopupOpen,
  setIsPaymentPopupOpen,
  setIsSwitchShopPopupOpen,
} from '../../store/reducers/uiSlice';
import {
  clearPreUserInvitation,
  clearUserSlice,
} from '../../store/reducers/userSlice';
import store from '../../store/store';

declare const window: any;

function localStorageHardReset() {
  store.dispatch(clearUserSlice());
  store.dispatch(clearPreUserInvitation());
  store.dispatch(clearAuthSlice());
  store.dispatch(clearChatSlice());
  store.dispatch(clearUISlice());
  store.dispatch(setIsPaymentPopupOpen(false));
  store.dispatch(setIsSwitchShopPopupOpen(false));
  store.dispatch(setAutoSelectAgencyRole(false));
  store.dispatch(setIsHelpSetupPopupOpen(false));
  store.dispatch(setHasSkippedHelpSetup(false));

  // Preserve per-seller onboarding-completion markers across logout. The
  // streamlined account-type onboarding creates NO shop, so completion has no
  // durable backend home today; without this, logout wipes the only record and
  // the next login re-traps the user in onboarding. Keys are seller-scoped
  // (`adup_onboarding_done_<sellerId>`) so a different user on the same browser
  // is unaffected.
  const preservedOnboarding: Record<string, string> = {};
  try {
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith('adup_onboarding_done_')) {
        const value = window.localStorage.getItem(key);
        if (value !== null) preservedOnboarding[key] = value;
      }
    }
  } catch (_e) {
    // ignore — preservation is best-effort
  }

  window.localStorage.clear();

  try {
    Object.entries(preservedOnboarding).forEach(([key, value]) => {
      window.localStorage.setItem(key, value);
    });
  } catch (_e) {
    // ignore
  }
}

export default localStorageHardReset;
